import type { ISellerProfile } from '../types/auth.types';

/** Fields clients may send on PUT /users/me (matches SellerProfileDto). */
const WRITABLE_SELLER_PROFILE_KEYS = [
  'storeDisplayName',
  'storeBio',
  'businessType',
  'country',
  'marketingConsent',
  'termsAcceptedAt',
  'skippedSteps',
  'notificationPreferences',
] as const satisfies readonly (keyof ISellerProfile)[];

export function pickWritableSellerProfile(
  profile?: Partial<ISellerProfile> | null,
): ISellerProfile | undefined {
  if (!profile) return undefined;

  const picked: ISellerProfile = {};
  for (const key of WRITABLE_SELLER_PROFILE_KEYS) {
    if (profile[key] !== undefined) {
      (picked as Record<string, unknown>)[key] = profile[key];
    }
  }
  return Object.keys(picked).length > 0 ? picked : undefined;
}

export function mergeWritableSellerProfile(
  existing?: Partial<ISellerProfile> | null,
  patch?: Partial<ISellerProfile> | null,
): ISellerProfile | undefined {
  return pickWritableSellerProfile({
    ...pickWritableSellerProfile(existing),
    ...pickWritableSellerProfile(patch),
  });
}
